<div>
  <p>U bevindt zich onder uw <span class="strong">minimumvoorraad</span>.</p>
  <div class="text-margin">
    <p>
      Gezien onze leveringstermijnen en uw gemiddelde afname, willen wij u
      tijdig verwittigen omtrent uw <span class="strong">voorraad</span>.
    </p>
    <p>
      Wij adviseren u, vrijblijvend, om een
      <span class="strong">nieuwe voorraad borden</span> aan te leggen, zo
      voorkomen we samen dat er jobs in wacht komen te staan.
    </p>
  </div>
</div>
<div class="button-container">
  <button mat-button class="order-stock-button" (click)="orderStock()">
    + Nieuwe voorraad bestellen
  </button>
  <button mat-button class="close-button" (click)="close()">
    Sluiten
  </button>
</div>
